import { FormControl, Select, styled } from "@mui/material";
import { SelectProps } from "@mui/material/Select";

export const Styled = {
    FormControl: styled(FormControl)`
        min-width: auto;
        width: auto;
        padding: 0;
        & .MuiInputBase-root {
            font-size: 0.8rem;
            padding: 2;
            border: none;
            width: fit-content;
        }

        & .MuiSelect-select {
            padding: 0px;
            min-height: auto;
            line-height: normal;
        }
    `,
    Select: styled(Select as React.ComponentType<SelectProps<number>>)`
        .MuiSelect-select {
            padding-right: 0px !important;
            min-height: auto;
            line-height: normal;
            display: flex;
            align-items: center;
        }
        & .MuiSvgIcon-root {
            display: none;
        }
    `,
};
